import loadable from "@loadable/component";
import * as React from "react";
import { Route, Switch } from "react-router-dom";
import { NotFoundPage } from "@pages/common/404";
import { answersToQuestions, onlineLanding, publicContracts, siteAboutUs, siteConcert, siteCreatingTickets, siteEvent, siteGenericPage, siteIndex, siteOfflineLanding, sitePrivacyPolicy, siteSchedule, siteStudioDetail, siteStudios, siteSubscriptionsBase, thxPage, } from "@urls";
import { ConcertPage } from "@/pages/site/ConcertPage";
import { PublicContract } from "@/components/student/PublicContract";
const LoadableOfflineLanding = loadable(() => import("@pages/site/OfflineLanding"));
const LoadableOnlineLanding = loadable(() => import("@pages/site/OnlineLanding"));
const LoadableStudios = loadable(() => import("@pages/site/Studios"));
const LoadableSubscriptions = loadable(() => import("@pages/site/Subscriptions"));
const LoadableSchedule = loadable(() => import("@pages/site/Schedule"), { ssr: false });
const LoadableAboutUs = loadable(() => import("@pages/site/AboutUs"));
const LoadableIndex = loadable(() => import("@pages/site/Index"));
const LoadableGenericPage = loadable(() => import("@pages/site/GenericPage"));
const LoadableAnswersToQuestions = loadable(() => import("@pages/site/AnswersToQuestions"));
const EventsPage = loadable(() => import("@pages/site/EventsPage"));
const CreatingTicketsPage = loadable(() => import("@pages/site/CreatingTicketsPage"));
const ThxPage = loadable(() => import("@pages/site/ThxPage"));
export const SiteRoutes = () => {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: siteOfflineLanding, component: LoadableOfflineLanding }),
        React.createElement(Route, { path: onlineLanding, component: LoadableOnlineLanding }),
        React.createElement(Route, { path: thxPage, component: ThxPage }),
        React.createElement(Route, { path: [
                siteStudioDetail,
                siteStudios,
            ], component: LoadableStudios }),
        React.createElement(Route, { path: siteSubscriptionsBase, component: LoadableSubscriptions }),
        React.createElement(Route, { path: siteSchedule, component: LoadableSchedule }),
        React.createElement(Route, { path: siteAboutUs, component: LoadableAboutUs }),
        React.createElement(Route, { path: siteGenericPage, component: ({ match }) => (React.createElement(LoadableGenericPage, { slug: match.params.slug })) }),
        React.createElement(Route, { path: answersToQuestions, component: LoadableAnswersToQuestions }),
        React.createElement(Route, { path: sitePrivacyPolicy, render: () => React.createElement(LoadableGenericPage, { slug: "privacy-policy" }) }),
        React.createElement(Route, { exact: true, path: siteEvent, component: EventsPage }),
        React.createElement(Route, { exact: true, path: siteConcert, component: ConcertPage }),
        React.createElement(Route, { exact: true, path: siteCreatingTickets, component: CreatingTicketsPage }),
        React.createElement(Route, { exact: true, path: publicContracts, component: PublicContract }),
        React.createElement(Route, { exact: true, path: siteIndex, component: LoadableIndex }),
        React.createElement(Route, { path: "*", component: NotFoundPage })));
};
export default SiteRoutes;
